import React, { useState } from 'react';

import RMDBLogo from '../../images/T2.png';

import { FaBars, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {
  Nav,
  NavLink,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
} from "./Header.Navbar.style.js";
import { useUserAuth } from '../../context/UserAuthContext';

import { Wrapper, Content, LogoImg } from './Header.Styles';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoggedIn, logout } = useUserAuth();
  const navigate = useNavigate();

  const toggle = () => setIsOpen(prev => !prev);
  const close = () => setIsOpen(false);
  const handleLogout = () => { logout(); close(); navigate('/'); };

  return (
    <Wrapper>
      <Content>
        <Nav>
          <Bars onClick={toggle}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </Bars>
          <LogoImg src={RMDBLogo} alt='mycinemadb-logo' />
          {/* <TMDBLogoImg src={TMDBLogo} alt='tmdb-logo'/> */}
          <NavMenu isOpen={isOpen}>
            <NavLink to="/" exact onClick={close}>Home</NavLink>
            <NavLink to="/filmrecommendation" activeStyle onClick={close}>Film Recommendation AI</NavLink>
            <NavLink to="/about" activeStyle onClick={close}>About</NavLink>
            <NavLink to="/blogs" activeStyle onClick={close}>Blog</NavLink>
            {isLoggedIn && (
              <NavLink to="/my-films" activeStyle onClick={close}>My Films</NavLink>
            )}
            {!isLoggedIn && (
              <NavLink to="/sign-up" activeStyle onClick={close}>Sign Up</NavLink>
            )}
          </NavMenu>

          <NavBtn isOpen={isOpen}>
            {isLoggedIn ? (
              <NavBtnLink as="button" onClick={handleLogout} style={{ cursor: 'pointer', background: 'transparent', border: '2px solid currentColor' }}>
                Sign Out
              </NavBtnLink>
            ) : (
              <NavBtnLink to="/sign-in" onClick={close}>Sign In</NavBtnLink>
            )}
          </NavBtn>
        </Nav>
      </Content>
    </Wrapper>
  );
};

export default Header;